import type { TenantConfigManifestSection, TenantConfigPlane, TenantPlatformAction, TenantStatus } from '@today/types'
import { apiClient } from './api.client'

/** The console manifest (TO-374): what the caller may see and do for one tenant on one plane. */
export interface TenantConfigManifest {
	tenant: { id: string; slug: string; name: string; status: TenantStatus }
	plane: TenantConfigPlane
	sections: TenantConfigManifestSection[]
	platformActions: TenantPlatformAction[]
}

export const tenantConfigService = {
	/** Platform plane — `GET /admin/tenants/{tenantId}/config` (Super-Admin). */
	async getPlatform(tenantId: string): Promise<TenantConfigManifest> {
		const { data } = await apiClient.get<TenantConfigManifest>(`/admin/tenants/${encodeURIComponent(tenantId)}/config`)
		return data
	},

	/** Tenant plane — `GET /t/{slug}/admin/config` (the caller's own tenant). */
	async getTenant(slug: string): Promise<TenantConfigManifest> {
		const { data } = await apiClient.get<TenantConfigManifest>(`/t/${encodeURIComponent(slug)}/admin/config`)
		return data
	},
}
